const SUPPORTED_FIELD_TYPES = new Set(['string', 'long_text', 'document'])

export function getSupportedCustomCodeSourceFields(fields: FieldDto[]) {
    return fields.filter((field) => SUPPORTED_FIELD_TYPES.has(field.type))
}
